export const MOCK_AUTH_TOKEN_PREFIX = 'loadtest:'
const ONE_HUNDRED_YEARS_IN_MS = 100 * 365 * 24 * 60 * 60 * 1000

export const isMockAuthToken = (
  token?: string | null
): token is string =>
  typeof token === 'string' && token.startsWith(MOCK_AUTH_TOKEN_PREFIX)

export const getMockExternalId = (token?: string | null) => {
  if (!isMockAuthToken(token)) {
    return undefined
  }

  const externalId = token.slice(MOCK_AUTH_TOKEN_PREFIX.length)
  return externalId || undefined
}

export const createMockAuth = (externalId: string, now = Date.now()) => {
  const token = `${MOCK_AUTH_TOKEN_PREFIX}${externalId}`

  return {
    accessToken: token,
    refreshToken: token,
    accessTokenExpiry: now + ONE_HUNDRED_YEARS_IN_MS,
    refreshTokenExpiry: now + ONE_HUNDRED_YEARS_IN_MS,
  }
}
